//================================================================
//  Component: Dynamic Rating Badge
//================================================================

//  Purpose: This is the badge that displays a vendor risk rating/grade

//  Properties:
//    - letter = {A string, this is the UpGuard grade for the vendor}

//  Example:
//    <DynamicRatingBadge
//      letter={vendor?.securitygrade}
//    ></DynamicRatingBadge>    

//================================================================


//Libraries
import React from 'react';

export default function DynamicRatingBadge({
  letter
}) {

    //------------------------------------------------------
    //  Define Variables
    //------------------------------------------------------

    const colorsObj = {
        'A': '#61BE81',
        'B': '#B1D883',
        'C': '#FDE68A',
        'D': '#F99C73',
        'F': '#C84F52',
    }

    //------------------------------------------------------
    //  HTML
    //------------------------------------------------------

    return (
        <div className='relative flex items-center justify-center w-6 h-6 rounded-full border-1' style={{ borderColor: colorsObj[letter] }}>
            <div className='absolute inset-0 rounded-full'style={{ backgroundColor: colorsObj[letter], opacity: 0.2 }}></div>

            <span className='relative text-[16px]' style={{ color: colorsObj[letter] }}>
                {letter}
            </span>
        </div>
    );

}
